import type { CopyShape } from "@tami/core/intl";

import type { DEMO_ORG_MODE_SWITCH_COPY_PT_BR } from "../demo-org-mode-switch.copy";

export const DEMO_ORG_MODE_SWITCH_COPY_EN_US: CopyShape<typeof DEMO_ORG_MODE_SWITCH_COPY_PT_BR> = {
  ariaLabel: "Pick the account type for the demo",
  creator: {
    label: "I'm a Creator",
    shortLabel: "Creator",
    hint: "You and your socials",
  },
  collab: {
    label: "I'm a Collab",
    shortLabel: "Collab",
    hint: "You and your creator roster",
  },
};
